'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment', 'AVRO.Common.DataService'];
module.exports = angular.module('AVRO.Common.UserAction', dependencies).service('UserActionService', require('./services/UserActionService'));